export const convertCity = city => {
	switch (city) {
		case '1':
			return 'Riviera Nayarit - Puerto Vallarta';
		case '2':
			return 'Los Cabos';
		case '3':
			return 'Cozumel';
		case '4':
			return 'Cancún';
		case '5':
			return 'Playa del Carmen';
		case '6':
			return 'Tulum';
		case '7':
			return 'Veracruz';
		case '8':
			return 'Puerto Escondido';
		case '9':
			return 'Mérida - Puerto Progreso';
		case '10':
			return 'Mazatlán';
		//case '11':
		//	return 'Acapulco';
		case '12':
			return 'Acapulco';
		default:
			return null;
	}
};
export const convertMembership = membership => {
	switch (membership) {
		case '1':
			return 'Sandy';
		case '2':
			return 'Michelle';
		case '3':
			return 'Katrina';
		case '4':
			return 'Wilma';
		default:
			return null;
	}
};

export const convertBusinessLine = businessLine => {
	switch (businessLine) {
		case '1':
			return 'Hospedaje/Restaurantes y Eventos';
		case '2':
			return 'Transporte';
		case '3':
			return 'Tour Operador y Proveedor de Experiencias';
		case '4':
			return 'Servicios en Playa';
		case '5':
			return 'Renta de Propiedades Vacacionales';
		case '6':
			return 'Bienes Raices y Administración de Propiedades';
		case '7':
			return 'Cultura';
		case '8':
			return 'Servicios de Salud';
		case '9':
			return 'Asesoria';
		case '10':
			return 'Locales Comerciales';
		case '11':
			return 'Otros';
		case '12':
			return 'Casa Habitación';
		default:
			return null;
	}
};

// const percentagesByCity = {
// 	'Los Cabos': 0.091616,
// 	'Riviera Nayarit - Puerto Vallarta': 0.087726,
// 	Cancún: 0.095118,
// 	'Playa del Carmen': 0.117681,
// 	Tulum: 0.119821,
// 	Cozumel: 0.134215,
// 	'Puerto Escondido': 0.083836,
// 	'Mérida - Puerto Progreso': 0.116709,
// 	'Acapulco': 0.090644,
// };

const percentagesByCity = {
	'Los Cabos': 0.066525,
	'Riviera Nayarit - Puerto Vallarta': 0.064191,
	Cancún: 0.079751,
	'Playa del Carmen': 0.130325,
	Tulum: 0.16806,
	Cozumel: 0.190625,
	'Puerto Escondido': 0.057966,
	'Mérida - Puerto Progreso': 0.125462,
	Acapulco: 0.079751,
};
function percentagesByCityWithDiscount(discount) {
	return 1 - discount / 100;
}

export const calculatePrice = (city, amount) => {
	const somus = 0.98;
	const pnr = (amount * percentagesByCity[convertCity(city)]) / 100;
	const somusAmount = Number((pnr / somus).toFixed(2));
	const PNS = Number((somusAmount / (1 - 0.03 - 0.09 - 0.05)).toFixed(2));
	const subtotal = Number(((PNS + 45) * 1.16).toFixed(2));
	const total = Number((subtotal * 1.035).toFixed(2));
	return total;
};

export const calculatePriceNew = (city, compensationLimit, discount = 0) => {
	const cuotaCliente =
		percentagesByCity[convertCity(city)] * percentagesByCityWithDiscount(discount);
	const primaNeta = Number((compensationLimit * cuotaCliente).toFixed(2));

	// Determinar gastos de expedición según primaNeta
	let gastosDeExpedicion;
	switch (true) {
		case primaNeta >= 1 && primaNeta <= 1000:
			gastosDeExpedicion = 100;
			break;
		case primaNeta >= 1001 && primaNeta <= 5000:
			gastosDeExpedicion = 125;
			break;
		case primaNeta >= 5001 && primaNeta <= 15000:
			gastosDeExpedicion = 175;
			break;
		case primaNeta >= 15001 && primaNeta <= 100000:
			gastosDeExpedicion = 225;
			break;
		default:
			gastosDeExpedicion = 400;
	}

	const primaPlusGastos = primaNeta + gastosDeExpedicion;
	const iva = primaPlusGastos * 0.16;
	const primaTotal = Number((primaPlusGastos + iva).toFixed(2));

	return {
		cuotaCliente,
		primaNeta,
		gastosDeExpedicion,
		primaPlusGastos,
		iva,
		primaTotal,
	};
};
